import { cn } from "@design-system/utils";
import { ChevronDown } from "lucide-react";
import * as React from "react";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../dropdown-menu";

import { SidebarMenuButton } from "./sidebar";

function SidebarDropdownMenu({
  children,
  ...props
}: React.ComponentProps<typeof DropdownMenu>) {
  return (
    <DropdownMenu
      data-slot="sidebar-dropdown-menu"
      data-sidebar="dropdown-menu"
      {...props}
    >
      {children}
    </DropdownMenu>
  );
}

function SidebarDropdownMenuTrigger({
  className,
  children,
  ...props
}: React.ComponentProps<typeof DropdownMenuTrigger>) {
  return (
    <DropdownMenuTrigger
      data-slot="sidebar-dropdown-menu-trigger"
      data-sidebar="dropdown-menu-trigger"
      className={cn("", className)}
      asChild
      {...props}
    >
      {children}
    </DropdownMenuTrigger>
  );
}

const SidebarDropdownMenuButton = React.forwardRef<
  HTMLButtonElement,
  React.ComponentProps<typeof SidebarMenuButton> & {
    showChevron?: boolean;
  }
>(({ className, children, ...props }, ref) => {
  return (
    <SidebarMenuButton
      ref={ref}
      data-slot="sidebar-dropdown-menu-button"
      data-sidebar="dropdown-menu-button"
      className={cn("group w-full justify-start", className)}
      {...props}
    >
      {children}

      <ChevronDown className="ml-auto transition-transform duration-200 group-data-[state=open]:rotate-180" />
    </SidebarMenuButton>
  );
});
SidebarDropdownMenuButton.displayName = "SidebarDropdownMenuButton";

function SidebarDropdownMenuContent({
  className,
  ...props
}: React.ComponentProps<typeof DropdownMenuContent>) {
  return (
    <DropdownMenuContent
      data-slot="sidebar-dropdown-menu-content"
      data-sidebar="dropdown-menu-content"
      className={cn(
        "flex w-[var(--radix-popper-anchor-width)] flex-col gap-[2px]",
        className
      )}
      {...props}
    />
  );
}

function SidebarDropdownMenuItem({
  className,
  children,
  ...props
}: React.ComponentProps<typeof DropdownMenuItem>) {
  return (
    <DropdownMenuItem
      data-slot="sidebar-dropdown-menu-item"
      data-sidebar="dropdown-menu-item"
      className={cn(
        "py-2 pr-2 pl-[7px] text-sm [&>span]:pointer-events-none [&>svg]:size-4",
        className
      )}
      {...props}
    >
      {children}
    </DropdownMenuItem>
  );
}

export {
  SidebarDropdownMenu,
  SidebarDropdownMenuTrigger,
  SidebarDropdownMenuButton,
  SidebarDropdownMenuContent,
  SidebarDropdownMenuItem,
};
